/** Constante sin dependencias: evita TDZ en ciclos de import (ver cashSummaryQuery/cashDifferencesResolve). */
export const CASH_DIFFERENCES_PAGE_SIZE = 40;
